import React, { useState } from 'react';
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import _ from "lodash";
import i18n from "i18next";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { EmptyData } from "../../../../components/empty/emptyData";
import { PageHeader } from "../../../../components/page-header";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { useLazyGetLivestockTradeActivityListAllQuery } from "../../../../redux/api/organic/livestockTradeActivityApi";
import { EntLivestockTradeActivity } from "../../../../models/organic/livestockTradeActivity";
import { EntLivestockTradeActivityFilter } from "../../../../models/filters/organic/livestockTradeActivityFilter";
import { useLivestockTradeActivity } from "./useLivestockTradeActivity";
import { FilterLivestockTradeActivity } from "./FilterLivestockTradeActivity";
import { AddLivestockTradeActivityModal } from "./AddLivestockTradeActivity";

enum FormField {
  year,
  citizenshipId,
  productTypeIds,
  operationType,
  unitMeasurementIds,
  hsCode
}

const operationOptions = [
  { label: "Импорт", value: "IMPORT" },
  { label: "Экспорт", value: "EXPORT" },
];

export const LivestockTradeActivity = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedItem, setSelectedItem] = useState<EntLivestockTradeActivity>(new EntLivestockTradeActivity());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showReportModal, setShowReportModal] = useState<boolean>(false);
  const [form] = useForm();
  const { t } = useTranslation()

  const [getArchiveFolders] = useLazyGetLivestockTradeActivityListAllQuery();
  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntLivestockTradeActivity, EntLivestockTradeActivityFilter>({
	initialFilter: new EntLivestockTradeActivityFilter(),
	query: getArchiveFolders
  });

  const {
	onAddLivestockTradeActivity,
	onDeleteLivestockTradeActivity,
	onEditLivestockTradeActivity
  } = useLivestockTradeActivity(modal, () => {
	searchHandleClick();
  })
  const [height, setHeight] = useState<number>(0);

  const storedData = JSON.parse(localStorage.getItem("availableRoutes") || "[]");
  const isReportAvailable = storedData.some((route: any) => (route.alias === "/report" || route.alias === "/interactive-map-ws") && route.methodPost);

  const openAddModal = (item: EntLivestockTradeActivity) => {
	setSelectedItem(item);
	setShowModal(true);
  }

  const setEntityFromFields = (): EntLivestockTradeActivityFilter => {
	let filt: EntLivestockTradeActivityFilter = _.clone(filter);
	filt.year = form.getFieldValue(FormField.year) ?? null;
	filt.citizenshipId = form.getFieldValue(FormField.citizenshipId) ?? null;
	filt.productTypeIds = form.getFieldValue(FormField.productTypeIds) ?? null;
	filt.operationType = form.getFieldValue(FormField.operationType) ?? null;
	filt.unitMeasurementIds = form.getFieldValue(FormField.unitMeasurementIds) ?? null;
	filt.hsCode = form.getFieldValue(FormField.hsCode) ?? null;
	filt.page = 1;
	return filt;
  }

  const clearFields = () => {
	form.setFields([
	  { name: FormField.year, value: null },
	  { name: FormField.citizenshipId, value: null },
	  { name: FormField.productTypeIds, value: null },
	  { name: FormField.operationType, value: null },
	  { name: FormField.unitMeasurementIds, value: null },
	  { name: FormField.hsCode, value: null },
	]);
  }

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('Год') } </th>
		  <th>{ t('Гражданство') }</th>
		  <th>{ t('Тип продукта') }</th>
		  <th>{ t('Направление') }</th>
		  <th>{ t('Код ТНВЭД') }</th>
		  <th>{ t('Единицы измерения') }</th>
		  <th>{ t('Количество') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ? (
		  <tr>
			<th colSpan={ 7 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		) : null }
		{ data.length !== 0 ? data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item.year }</td>
			<td>{ i18n.language === 'ru' ? item.citizenship?.countryRu : item.citizenship?.countryKy }</td>
			<td>{ i18n.language === 'ru' ? item.productType?.nameRu : item.productType?.nameKy }</td>
			<td>
			  { operationOptions.find((o) => o.value === item.operationType)?.label || "-" }
			</td>
			<td>{ item.hsCode }</td>
			<td>{ i18n.language === 'ru' ? item.unitMeasurement?.nameRu : item.unitMeasurement?.nameKy }</td>
			<td>{ item.amount }</td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeleteLivestockTradeActivity(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) : (
		  <tr>
			<td colSpan={ 9 }>
			  <EmptyData/>
			</td>
		  </tr>
		) }
		</tbody>
	  </table>
	</div>
  );

  return (
	<>
	  <PageHeader
		title={ t('Внешняя и взаимная торговля') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type="secondary">
			{ t('general.records_found') } { totalItems }
		  </Typography.Text>
		}
	  />
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntLivestockTradeActivity())
		} }>
		  { t('general.add') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterLivestockTradeActivity
		  onSearch={ searchHandleClick }
		  onReset={ () => {
			clearFields();
			searchHandleClick()
		  } }
		  formField={ FormField }
		  form={ form }
		/> }
		setHeight={ setHeight }
		table={ table }
	  />

	  <AddLivestockTradeActivityModal
		item={ selectedItem }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedItem.id !== null ? onEditLivestockTradeActivity : onAddLivestockTradeActivity }
	  />
	  { contextHolder }
	</>
  );
}


